// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PaymentProviderIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PaymentProvider/outline"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.632 14.827c0 1.245.955 2.249 2.142 2.249h2.422c1.032 0 1.872-.879 1.872-1.96 0-1.176-.512-1.591-1.274-1.861l-3.889-1.351c-.762-.27-1.273-.685-1.273-1.863 0-1.08.839-1.958 1.871-1.958h2.422c1.187 0 2.143 1.003 2.143 2.248M8.843 6.79v11.578M17.033 7.706l4.161-4.161v2.774M21.194 3.545H18.42M21.6 10.43l-4.16 4.16v-2.774M17.44 14.59h2.773"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.053 1.688-2.895 1.375-4.053-1.376-3.811 1.375L1 1v22l4.294-2.063L9.105 23l4.053-2.063L17.21 23v-4.368"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default PaymentProviderIcon;